import React from 'react';
import PropTypes from 'prop-types';

import TemplateDefault from '../../templates/default/default';
import Stage from '../../organisms/stage/stage';
import Pagination from '../../organisms/pagination/pagination';

import FloorPlan from '../../organisms/floor-plan/floorPlan';
import ExhibitionContainer from '../../organisms/exhibition-container/curatedExhibitionContainer';

const CuratedExhibition = ({
  data: { curatedExhibitionContent = [], meta = {}, floorPlanDataUrl }
}) => {
  return (
    <TemplateDefault>
      <Stage />
      <ExhibitionContainer
        data={curatedExhibitionContent}
        hidePaginationArrow={meta && meta.pagination && meta.pagination.total_pages < 2}
      />
      <FloorPlan dataUrl={floorPlanDataUrl} />
      {meta && meta.pagination && meta.pagination.total_pages > 1 && (
        <Pagination
          pageType="curatedExhibition"
          totalPages={parseInt(meta.pagination.total_pages, 10)}
          currentPage={parseInt(meta.pagination.current_page, 10)}
        />
      )}
    </TemplateDefault>
  );
};

CuratedExhibition.propTypes = {
  data: PropTypes.shape({
    curatedExhibitionContent: PropTypes.arrayOf([PropTypes.shape]),
    meta: PropTypes.shape({
      pagination: PropTypes.shape()
    }),
    floorPlanDataUrl: PropTypes.string.isRequired
  })
};

export default CuratedExhibition;
